// 这是一个空的Vue入口文件，你可以在这里开始你的新应用开发
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import './assets/styles/main.scss'
import apiClient from './api/config'
import { installResizeObserverHandler } from './utils/resize-observer-handler'

// 创建一个临时的根组件，以便应用能够启动
const app = createApp(App)
app.use(router)
app.use(store)
app.use(ElementPlus)

// 配置全局axios实例
app.config.globalProperties.$http = apiClient

// 安装 ResizeObserver 错误处理器
installResizeObserverHandler()

// 初始化共享时间筛选器
store.dispatch('initSharedTimeFilter')

// 挂载应用
app.mount('#app')
